import { createSideNameValidation } from "../createSideNameValidation";
import { buildValidationInput } from "./pdp_build_validation_input";

const ACTIVE_CARVING_TEXT_BLOCK_SELECTOR =
  ".js-carving-text1-block, .js-carving-text2-block";

/**
 * バリデーション対象 input が現在ユーザー操作可能か判定する。
 * block 構造（ballpen）では hidden / disabled fieldset 内を除外する。
 * flat 構造（name9-vivo 等）では block が無いため常に true。
 */
function isActiveValidationInput(inputEl: HTMLInputElement): boolean {
  const block = inputEl.closest(ACTIVE_CARVING_TEXT_BLOCK_SELECTOR);
  if (!block || !(block instanceof HTMLElement)) return true;

  const fieldset = block.querySelector("fieldset");
  return (
    !block.hidden &&
    !(fieldset instanceof HTMLFieldSetElement && fieldset.disabled)
  );
}

/**
 * 入力フィールドと同スコープ内に書体ラジオがあるか判定する
 * @param inputEl 入力フィールド
 * @returns 書体ラジオがあれば true
 */
function hasFont(inputEl: HTMLInputElement): boolean {
  const scope = inputEl.closest(".js-validation-scope");
  return Boolean(scope?.querySelector(`[data-validation-part="engraving-font"]`));
}

const { init, syncValidationState } = createSideNameValidation({
  buildInput: buildValidationInput,
  hasFont,
  isActiveInput: isActiveValidationInput,
  findFontRadios: (inputEl) => {
    const scope = inputEl.closest(".js-validation-scope");
    return scope?.querySelectorAll('[data-validation-part="engraving-font"]');
  },
  findMaxLengthDisplayEl: (inputEl) => {
    const textBlock =
      inputEl.closest('.js-carving-text1-block') ??
      inputEl.closest('.js-carving-text2-block');

    if (textBlock) {
      return textBlock.querySelector<HTMLElement>('.js-validation-display-max-length');
    }

    const scope = inputEl.closest('.js-validation-scope');
    return scope?.querySelector<HTMLElement>('.js-validation-display-max-length') ?? null;
  },
});

/**
 * この script は多重実行される可能性があるため多重初期化対策を入れる。
 */
export function bootPdpSideNameValidation(): void {
  // 多重初期化対策
  if (document.documentElement.dataset.sideNameValidationPdpBooted === "1") return;
  document.documentElement.dataset.sideNameValidationPdpBooted = "1";

  init();

  document.addEventListener("carving-blocks:synced", () => {
    syncValidationState();
  });
}